import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { contact } from '../../portfolio';
import CustomAlert from './CustomAlert';
import './Contact.css';
import { Mail } from '@material-ui/icons';

const Contact = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [contactNumber, setContactNumber] = useState('');
  const [message, setMessage] = useState('');
  const [alertMessage, setAlertMessage] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'name') setName(value);
    else if (name === 'email') setEmail(value);
    else if (name === 'contactNumber') setContactNumber(value);
    else if (name === 'message') setMessage(value);
  };

  const isValidPhoneNumber = (number) => {
    const phoneRegex = /^[0-9]{10}$/;
    return phoneRegex.test(number);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Check if any field is empty
    if (!name.trim() || !email.trim() || !contactNumber.trim() || !message.trim()) {
      setAlertMessage('Please fill in all fields.');
      return;
    }

    // Validate phone number
    if (!isValidPhoneNumber(contactNumber)) {
      setAlertMessage('Please enter a valid 10-digit contact number.');
      return;
    }

    // Prepare the template parameters for EmailJS
    const templateParams = {
      from_name: name,
      from_email: email,
      contact_number: contactNumber,
      message: message,
      service_name: 'Your Service Name' // Replace with your service name or any identifier
    };

    // Sending email using EmailJS
    emailjs.send('service_2mqsywb', 'template_r5938dp', templateParams, '9uU0_y4apGQbhuta9')
      .then((result) => {
        console.log('Email sent successfully:', result.text);
        setAlertMessage('Thank you, your message has been sent successfully!');
        setName('');
        setEmail('');
        setContactNumber('');
        setMessage('');
      }, (error) => {
        console.error('Failed to send email:', error.text);
        setAlertMessage('Sorry, there was an issue sending your message. Please try again later.');
      });
  };

  if (!contact.email) return null;

  return (
    <section className='section_contact center' id='contact'>
      <h2 className='section__title'>Contact</h2>
      <form onSubmit={handleSubmit}>
        <div className='contact__form-group'>
          <label htmlFor='name'>Name:</label>
          <input
            type='text'
            id='name'
            name='name'
            value={name}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className='contact__form-group'>
          <label htmlFor='email'>Email:</label>
          <input
            type='email'
            id='email'
            name='email'
            value={email}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className='contact__form-group'>
          <label htmlFor='contactNumber'>Contact Number:</label>
          <input
            type='text'
            id='contactNumber'
            name='contactNumber'
            value={contactNumber}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className='contact__form-group'>
          <label htmlFor='message'>Message:</label>
          <textarea
            id='message'
            name='message'
            value={message}
            onChange={handleInputChange}
            rows={4}
            required
          />
        </div>
        <button type='submit' className='contact__btn contact__btn--outline'>
          Send Email 
        </button>
      </form>
     <div className='mail'>
      <p className='contact__p'>Or Email me at :    {contact.email}</p>   <Mail></Mail>  </div>
      <CustomAlert message={alertMessage} onClose={() => setAlertMessage('')} />
    </section>
  );
};

export default Contact;
